var waitFor = require("../utils/waitFor");
var matchHeight = require("../lib/matchheight");

waitFor(".mh", function () {
  if ($(".mh").matchHeight) $(".mh").matchHeight();
});
